module.exports = __webpack_public_path__ + "media/images/googleplay-1b5c638d075e240a75922c8e992d219e.png";